import { serializeJsonLd } from "lib/seo";

const SchemaSet = ({ schemaData }: any) => schemaData ? (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: serializeJsonLd(schemaData) }}
  />
) : null;

export default SchemaSet;
